(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jds-footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function scoreToStars(score) { var s = parseFloat(score); if (isNaN(s)) return '★★★★½'; var full = Math.floor(s); var frac = s - full; var stars = ''; for (var i = 0; i < full; i++) stars += '★'; if (frac >= 0.25 && frac < 0.75) stars += '½'; return stars; }
  function applyRating(score) { var s = parseFloat(score); if (isNaN(s) || s <= 0) return false; var elScore = document.getElementById('jds-badge-score'); var elStars = document.getElementById('jds-badge-stars'); if (elScore) elScore.textContent = s.toFixed(1); if (elStars) elStars.textContent = scoreToStars(s); return true; }
  function readWidget() { var w = document.querySelector('.jdgm-all-reviews-badge[data-average-rating]'); if (w) { var r = w.getAttribute('data-average-rating'); if (r && parseFloat(r) > 0) { applyRating(r); return true; } } return false; }
  if (!readWidget()) {
    document.addEventListener('jdgm:all-reviews-badge:loaded', function () { readWidget(); });
    document.addEventListener('jdgm:widget:loaded', function () { readWidget(); });
    var obs = new MutationObserver(function () { if (readWidget()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-average-rating'] });
    setTimeout(function () { obs.disconnect(); }, 12000);
  }

  // Offer pill tooltip — click toggles, click outside / Esc closes, hover also opens on desktop
  document.querySelectorAll('[data-offer-wrap]').forEach(function (wrap) {
    var trigger = wrap.querySelector('[data-offer-trigger]');
    if (!trigger) return;
    function open()   { wrap.classList.add('is-open');    trigger.setAttribute('aria-expanded', 'true'); }
    function close()  { wrap.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }
    function toggle(){ wrap.classList.contains('is-open') ? close() : open(); }
    trigger.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jds-social-proof"] && !Shopify.designMode) return;
  try {
    
(function () {
  function scoreToStars(s) {
    var f = Math.floor(s), h = (s - f) >= 0.25 && (s - f) < 0.75, r = '';
    for (var i = 0; i < f; i++) r += '★';
    if (h) r += '½';
    return r;
  }
  function applyRating(score) {
    var s = parseFloat(score);
    if (isNaN(s) || s <= 0) return false;
    var eS = document.getElementById('jds-tb-score');
    var eI = document.getElementById('jds-tb-stars');
    if (eS) eS.textContent = s.toFixed(1);
    if (eI) eI.textContent = scoreToStars(s);
    return true;
  }
  function readWidget() {
    var w = document.querySelector('.jdgm-all-reviews-badge[data-average-rating]');
    if (w) { var r = w.getAttribute('data-average-rating'); if (r && parseFloat(r) > 0) { applyRating(r); return true; } }
    return false;
  }
  if (readWidget()) return;
  document.addEventListener('jdgm:all-reviews-badge:loaded', readWidget);
  document.addEventListener('jdgm:widget:loaded', readWidget);
  var obs = new MutationObserver(function () { if (readWidget()) obs.disconnect(); });
  obs.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-average-rating'] });
  setTimeout(function () { obs.disconnect(); }, 12000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
